module.exports = __webpack_public_path__ + "media/our_mission/Andre_und_Matti-35a5add4.webp";